import { render, staticRenderFns } from "./reset-pwd.vue?vue&type=template&id=56a19e5a&"
import script from "./reset-pwd.vue?vue&type=script&lang=js&"
export * from "./reset-pwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports